import { createApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { environment } from '../environments/environment';
import {
  APP_BASE_HREF,
  HashLocationStrategy,
  LocationStrategy
} from '@angular/common';
import { createCustomElement } from '@angular/elements';

export const provideWebComponent = async (
  selector: string,
  outlet: string,
  routerComponent: any,
  wrapperComponent: any,
  environmentProvider: Function
) => {
  const app = await createApplication({
    providers: [
      provideRouter([
        {
          path: '',
          outlet: outlet,
          component: routerComponent
        }
      ]),
      environmentProvider(),
      { provide: 'environment', useValue: environment },
      { provide: LocationStrategy, useClass: HashLocationStrategy },
      { provide: APP_BASE_HREF, useValue: '' }
    ]
  });

  const WebComponent = createCustomElement(wrapperComponent, {
    injector: app.injector
  });

  if (!customElements.get(selector)) {
    customElements.define(selector, WebComponent);
  }
};
